import 'phaser';
import MenuState from "./MenuState.js";
//import HelpState from "./HelpState.js";
import InitState from "./InitState.js";
import GameState from "./GameState.js";
//import PreInitState from "./PreInitState.js";
import {getDevice} from "./lib.js";



// Config for game
var config = {
  type: Phaser.CANVAS,
  width: GameConfig.gameWidth,//(550+70),
  height: GameConfig.gameHeight,//(400+200),
  backgroundColor: GameConfig.backgroundColor,
  parent: "game-container",
  scene: [ InitState, MenuState, GameState],
  callbacks: {
    postBoot: function (game) {
      // In v3.15, you have to override Phaser's default styles
      game.canvas.style.width = '100%';
      game.canvas.style.height = '100%';
    }
  }
};
var soundflg = localStorage.getItem("game4_opt");
if(soundflg){
  GameConfig.sound = JSON.parse(soundflg);
}else{
  var dev = getDevice();
  if(dev == 'sp' || dev == 'iPad'){
    GameConfig.sound = false;
  }else{
    GameConfig.sound = true;
  }
}
// Create game
var game = new Phaser.Game(config);